import axios from 'axios'

export const getCurrentUser = () => {
  return axios
    .get('/api/v1/current_user')
    .then((res) => res.data)
    .catch(() => undefined)
}
